import { IconComponent, SmallIcon } from "@nova/component-icons"
import { useTranslation } from "@nova/use-translation"

export const WorkspaceBodyListSectionHeader = ({
    title,
    Icon,
}: {
    title: string
    Icon: IconComponent
}) => {
    const { t } = useTranslation()
    return (
        <div className="relative w-full flex items-center gap-2 p-2 -ml-0.5 h-9">
            <SmallIcon Icon={Icon} className="text-gray-400" />
            <small className="xs text-gray-50 select-none">{t(title)}</small>
        </div>
    )
}
